module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hedo-intro-card1.2.ef00f161.jpg";